import {
  formatCampaignDollars,
  GiftPassPreviewPriceBasis,
  type GiftPassBundlePreviewPrice,
} from '@bonsai/shared';

import './gift-pass-bundle-editor.css';

function basisLabel(price: GiftPassBundlePreviewPrice, campaignName: string | null): string {
  const pass = formatCampaignDollars(price.basePriceCents);
  switch (price.basis) {
    case GiftPassPreviewPriceBasis.FALLBACK:
      return `${pass} fallback, no workshops nearby`;
    case GiftPassPreviewPriceBasis.FALLBACK_WITH_CAMPAIGN:
      return `${pass} fallback during ${campaignName ?? 'the running campaign'}`;
    default:
      return `${pass} ticket · ${price.workshopCount} ${price.workshopCount === 1 ? 'workshop' : 'workshops'}`;
  }
}

export interface BundleCostPriceRowProps {
  price: GiftPassBundlePreviewPrice;
  campaignName: string | null;
}

export function BundleCostPriceRow({ price, campaignName }: BundleCostPriceRowProps) {
  const label = <th scope="row">{basisLabel(price, campaignName)}</th>;
  const { bundlePriceCents, salePricePerPassCents } = price;
  if (bundlePriceCents === null || salePricePerPassCents === null) {
    return (
      <tr data-offered={false}>
        {label}
        <td colSpan={2} className="gpb-ed-warn">
          Not offered: the discount covers the whole bundle
        </td>
      </tr>
    );
  }
  return (
    <tr data-offered>
      {label}
      <td className="nb-tabular">{formatCampaignDollars(bundlePriceCents)}</td>
      <td className="nb-tabular">{formatCampaignDollars(salePricePerPassCents)}</td>
    </tr>
  );
}
